import moment from 'moment';
// Service
import AuthService from '../../services/auth.service';
// Reducer
import * as AuthReducer from './auth.reducers';

// Get Authorization Token ====================================================================================================

export const getAuth = () => async (dispatch) => {
  dispatch(AuthReducer.setGetAuthLoading());

  try {

    const response = await AuthService.getAuth();
    dispatch(AuthReducer.setGetAuthSuccess(response.data));

  } catch(error) {
    dispatch(AuthReducer.setGetAuthFailure(error.response?.data?.message || error.message));
  }

}

// Get Authorization Token via Interval ====================================================================================================

export const getAuthViaInterval = () => async (dispatch) => {
  try {

    const response = await AuthService.getAuth();
    dispatch(AuthReducer.setGetAuthSuccess(response.data));

  } catch(error) {
    console.log(error);
  }

}


// Clean Up Get Authorization Token Store ====================================================================================================

export const cleanUpGetAuthStore = () => (dispatch) => {
  dispatch(AuthReducer.setCleanUpGetAuthStore());
};


// Log In the user ====================================================================================================

export const logInUser = (data) => async (dispatch) => {
  dispatch(AuthReducer.setLoginLoading());
  try {
    const response = await AuthService.login(data);
    dispatch(AuthReducer.setLoginSuccess({
      ...response.data?.data,
      loginCliente: data.loginCliente,
      date: moment().format('DD/MM/YYYY | HH:MM:SS a'),
      rawDate: moment().format()
    }));
  } catch(error) {
    if (error.response?.data?.data?.codigoError === '18006') {
      const logOutData = {
        loginCliente: data?.loginCliente,
        ntv: error.response?.data?.data?.ntv,
      };
      dispatch(logOutUser(logOutData, true, data));
    } else {
      dispatch(AuthReducer.setLoginFailure(error.response?.data?.data?.descripcionError || error.message));
    }
  }
}

// Clean Up Log in Store ====================================================================================================

export const cleanUpLogInStore = () => (dispatch) => {
  dispatch(AuthReducer.setCleanUpLogInStore());
};


// Encrypt the user's password ====================================================================================================

export const encryptUserPassword = (data) => async (dispatch) => {
  dispatch(AuthReducer.setEncryptPasswordLoading());

  try {

    const response = await AuthService.encryptPassword(data);
    dispatch(AuthReducer.setEncryptPasswordSuccess(response.data));

  } catch(error) {
    dispatch(AuthReducer.setEncryptPasswordFailure(error.response?.data?.message || error.message));
  }

}


// Set The User's Mis Code ====================================================================================================

export const setMisCode = (data) => async (dispatch) => {
  dispatch(AuthReducer.setMisCode(data));
}


// Logs out the user ====================================================================================================

export const logOutUser = (data, closingSession, logInData) => async (dispatch) => {
  dispatch(AuthReducer.setLogOutLoading());

  try {

    await AuthService.logout(data);
    dispatch(AuthReducer.setLogOutSuccess());

    if (closingSession) {
      dispatch(logInUser(logInData));
    }

  } catch(error) {
    if (error.response?.data?.data?.codigoError === '18012') {
      dispatch(AuthReducer.setLogOutSuccess());
    } else {
      dispatch(AuthReducer.setLogOutFailure(error.response?.data?.message || error.message));
    }
  }

}